/**
 * Material Symbols Outlined icon, as used throughout the Stitch designs.
 * Browse names at https://fonts.google.com/icons
 */
export default function Icon({ name, size = 20, filled = false, className = '', ...rest }) {
  return (
    <span
      aria-hidden="true"
      className={`material-symbols-outlined leading-none shrink-0 ${className}`}
      style={{
        fontSize: size,
        ...(filled && { fontVariationSettings: '"FILL" 1, "wght" 400, "GRAD" 0, "opsz" 24' }),
      }}
      {...rest}
    >
      {name}
    </span>
  );
}
